import { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useInputField } from '~/shared/utils';

export const useInputFieldController = (
    name: string,
    rules: Record<string, unknown>,
    defaultValue?: string,
    helpText?: string
) => {
    const { control, trigger } = useFormContext();

    const {
        field: { onBlur, onChange, value },
        fieldState: { invalid, error, isTouched },
    } = useController({
        name,
        control,
        defaultValue,
        rules: rules,
    });

    const isValid = !invalid;
    const { fieldId, helpTextId, invalidMessageId, describedById, showHelpText } = useInputField({
        id: name,
        helpText,
    });

    useEffect(() => {
        if (value && !isTouched) {
            trigger([name]);
        }
    }, [value, isTouched]);

    return {
        onBlur,
        onChange,
        value,
        error,
        isTouched,
        isValid,
        fieldId,
        showHelpText,
        helpTextId,
        invalidMessageId,
        describedById,
    };
};
